export const CAPTCHA = "Captcha/success";
export const LOADING_CAPTCHA = "Captcha/loading";
export const LOGIN = "Login/success";
export const LOADING_LOGIN = "Login/loading";
export const LOGOUT = "Logout/success";
export const LOADING_LOGOUT = "Logout/loading";
export const VALIDATE_TOKEN = "ValidateToken/success";
export const LOADING_VALIDATE_TOKEN = "ValidateToken/loading";
export const REFRESH_TOKEN = "RefreshToken/success";
export const LOADING_REFRESH_TOKEN = "RefreshToken/loading";
export const VALIDATE_TOKEN_BSS = "ValidateTokenBSS/success";
export const LOADING_VALIDATE_TOKEN_BSS = "ValidateTokenBSS/loading";
export const IP_ADDRESS_DATAS = "IpAddressDatas/success";
export const LOADING_IP_ADDRESS_DATAS = "IpAddressDatas/loading";
export const TERMS_AND_CONDITIONS = "TermsAndConditions/success";
export const LOADING_TERMS_AND_CONDITIONS = "TermsAndConditions/loading";
export const LIST_WORD_STYLING = "ListWordStyling/success";
export const LOADING_LIST_WORD_STYLING = "ListWordStyling/loading";
export const HEADLINE = "Headline/success";
export const LOADING_HEADLINE = "Headline/loading";
export const LIST_LAYANAN = "ListLayanan/success";
export const LOADING_LIST_LAYANAN = "ListLayanan/loading";
export const LIST_PRODUK = "ListProduk/success";
export const LOADING_LIST_PRODUK = "ListProduk/loading";
export const CALL_TO_ACTION = "CallToAction/success";
export const LOADING_CALL_TO_ACTION = "CallToAction/loading";
export const LIST_ANNOUNCEMENT = "ListAnnouncement/success";
export const LOADING_LIST_ANNOUNCEMENT = "ListAnnouncement/loading";

